module.exports = __webpack_public_path__ + "static/media/Dermal_Fillers_Reading_List.75142a02.zip";